/* Amavil · Cabezal de ducha con filtro — landing interactions (prefix cdf-) */
(function () {
  'use strict';
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }

  /* ---------- GALLERY (arrows + swipe + thumbs) ---------- */
  function initGallery(root){
    var track=root.querySelector('.cdf-gallery-track');
    if(!track) return;
    var slides=track.querySelectorAll('.cdf-gslide');
    if(slides.length<=1) return;
    var thumbs=root.parentNode.querySelectorAll('.cdf-thumb');
    var i=0, n=slides.length;
    function go(k){
      i=(k+n)%n;
      track.style.transform='translateX(-'+(i*100)+'%)';
      thumbs.forEach(function(t,x){t.classList.toggle('is-active',x===i);});
      var tb=thumbs[i], tc=tb&&tb.parentNode;
      if(tc&&tc.scrollWidth>tc.clientWidth){var cb=tc.getBoundingClientRect(),bb=tb.getBoundingClientRect();tc.scrollTo({left:tc.scrollLeft+(bb.left-cb.left)-(cb.width-bb.width)/2,behavior:'smooth'});}
    }
    var prev=root.querySelector('.cdf-gallery-arrow.prev');
    var next=root.querySelector('.cdf-gallery-arrow.next');
    if(prev) prev.addEventListener('click',function(){go(i-1);});
    if(next) next.addEventListener('click',function(){go(i+1);});
    thumbs.forEach(function(t,x){t.addEventListener('click',function(){go(x);});});
    var x0=null;
    root.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
    root.addEventListener('touchend',function(e){
      if(x0===null) return;
      var dx=e.changedTouches[0].clientX-x0;
      if(Math.abs(dx)>40){ go(dx<0?i+1:i-1); }
      x0=null;
    },{passive:true});
    go(0);
  }

  /* ---------- REVIEW TABS ---------- */
  function initReviewTabs(root){
    var tabs=root.querySelectorAll('.cdf-tab');
    var cards=root.querySelectorAll('.cdf-rev-card');
    if(!tabs.length) return;
    function show(k){
      tabs.forEach(function(t){ t.classList.toggle('is-active', t.getAttribute('data-tab')===k); });
      cards.forEach(function(c){ c.classList.toggle('is-hidden', c.getAttribute('data-tab')!==k); });
    }
    tabs.forEach(function(t){ t.addEventListener('click',function(){ show(t.getAttribute('data-tab')); grid&&grid.scrollTo({left:0}); }); });
    show(tabs[0].getAttribute('data-tab'));
    /* mobile carousel arrows (swipe = native horizontal scroll) */
    var grid=root.querySelector('.cdf-rev-grid');
    function step(dir){
      if(!grid) return;
      var card=grid.querySelector('.cdf-rev-card:not(.is-hidden)');
      var w=card?card.getBoundingClientRect().width+12:grid.clientWidth*.9;
      var max=grid.scrollWidth-grid.clientWidth;
      var cur=grid.scrollLeft, next=cur+dir*w;
      if(dir>0){ next = cur>=max-2 ? 0 : Math.min(next,max); }
      else { next = cur<=2 ? max : Math.max(next,0); }
      grid.scrollTo({left:next,behavior:'smooth'});
    }
    var pv=root.querySelector('.cdf-rev-arrow.prev'), nx=root.querySelector('.cdf-rev-arrow.next');
    if(pv) pv.addEventListener('click',function(){step(-1);});
    if(nx) nx.addEventListener('click',function(){step(1);});
  }

  /* ---------- VIDEOS: buffer with the page, autoplay muted loop ---------- */
  function initVideos(){
    document.querySelectorAll('.cdf-wrap video').forEach(function(v){
      v.muted=true; v.loop=true; v.setAttribute('playsinline',''); v.setAttribute('preload','auto');
      try{ v.load(); }catch(e){}
      var p=v.play(); if(p && p.catch){ p.catch(function(){}); }
    });
  }

  /* ---------- STICKY BAR + BACK TO TOP ---------- */
  function initSticky(){
    var sticky=document.querySelector('.cdf-sticky');
    var top=document.querySelector('.cdf-top');
    var buy=document.getElementById('comprar');
    var footer=document.querySelector('footer');
    if(!sticky && !top) return;
    function onScroll(){
      var y=window.scrollY, vh=window.innerHeight;
      var docH=document.documentElement.scrollHeight;
      // Hidden on load (y=0). Appears only after ~half the page. Hides when the footer enters.
      var past = y > 200 && y > ((docH - vh) * 0.5);
      var footerIn = footer ? (footer.getBoundingClientRect().top < vh-20) : false;
      if(sticky) sticky.classList.toggle('is-visible', past && !footerIn);
      if(top){
        top.classList.toggle('is-visible', y>400);
        top.classList.toggle('raised', past && !footerIn);
      }
    }
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll,{passive:true});
    window.addEventListener('load',onScroll);
    onScroll();
    if(sticky){
      var sb=sticky.querySelector('.cdf-sticky-btn');
      if(sb) sb.addEventListener('click',function(){
        if(buy) window.scrollTo({top:buy.getBoundingClientRect().top+window.scrollY-110,behavior:'smooth'});
      });
    }
    if(top) top.addEventListener('click',function(){ window.scrollTo({top:0,behavior:'smooth'}); });
  }

  ready(function(){
    document.querySelectorAll('.cdf-gallery').forEach(initGallery);
    document.querySelectorAll('.cdf-reviews').forEach(initReviewTabs);
    initVideos();
    initSticky();
  });
})();
